import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './OperationsEmptyState.styles';
import { TransactionTabName } from '@/features/Profile/sections/Transactions/Transactions.types';

interface OperationsEmptyStateProps {
  activeTab: TransactionTabName;
}

const EMPTY_SUBTITLE_KEYS: Record<TransactionTabName, string> = {
  [TransactionTabName.Account]:
    'pages.cabinet.here_will_be_displayed_account_history',
  [TransactionTabName.Ads]: 'pages.cabinet.here_will_be_displayed_ads_history',
  [TransactionTabName.PaidAds]:
    'pages.cabinet.here_will_be_displayed_paid_placements_history',
};

export const OperationsEmptyState = ({
  activeTab,
}: OperationsEmptyStateProps) => {
  const { t } = useTranslation();

  return (
    <S.Container>
      <S.Image
        src="/images/transactions-empty.png"
        alt={t('pages.cabinet.you_dont_have_any_operations_yet')}
      />
      <S.Title>{t('pages.cabinet.you_dont_have_any_operations_yet')}</S.Title>
      <S.Subtitle>{t(EMPTY_SUBTITLE_KEYS[activeTab])}</S.Subtitle>
    </S.Container>
  );
};
